module.exports = new __parcel__URL__("Append.30cd52be.svg").toString();